/* istanbul ignore file */
import _ from 'lodash';
import { StyledTooltip, StyledTooltipMain } from './Tooltip.style';
import AssigneeList from './AssigneeList/AssigneeList';
import InvestmentBreakdown from './InvestmentBreakdown/InvestmentBreakdown';
import { boolPropsToClassNames } from 'common/utils/style.utils';
import IssuesList from './IssuesList/IssuesList';
import TooltipTitle from './TooltipTitle';
import TooltipHeader from './TooltipHeader';
import { TOOLTIP_VIEWS } from '../../../resource_types';

const Tooltip = ({ event, resourceType, raCost }) => {
  const pointData = _.get(event, 'point.extraData');
  const tooltipViews = _.get(resourceType, 'tooltipViews', []);
  const isOthersCategory = _.get(event, 'point.isOthers');

  const shouldShowInvestmentBreakdown = tooltipViews.includes(
    TOOLTIP_VIEWS.INVESTMENT_BREAKDOWN
  );
  const shouldShowIssuesList = tooltipViews.includes(TOOLTIP_VIEWS.ISSUES_LIST);

  return (
    <StyledTooltip
      className={boolPropsToClassNames({
        shouldShowInvestmentBreakdown,
        shouldShowIssuesList,
        isOthersCategory
      })}
      data-cy='allocation-over-time-tooltip'
    >
      <TooltipTitle event={event} pointData={pointData} />
      <TooltipHeader
        event={event}
        pointData={pointData}
        resourceType={resourceType}
        raCost={raCost}
      />
      {!isOthersCategory && (
        <StyledTooltipMain>
          {shouldShowInvestmentBreakdown && (
            <InvestmentBreakdown
              pointData={pointData}
              resourceType={resourceType}
            />
          )}
          {shouldShowIssuesList && (
            <IssuesList pointData={pointData} resourceType={resourceType} />
          )}
          <AssigneeList pointData={pointData} resourceType={resourceType} />
        </StyledTooltipMain>
      )}
    </StyledTooltip>
  );
};

export default Tooltip;
